export const truncateString = (str, limit) => {
  return str.length > limit ? str.substring(0, limit - 3) + "..." : str;
};

export const resolveTranslatedText = (value, key, fallback) => {
  const text = typeof value === "string" ? value.trim() : "";
  if (!text || text === key) {
    return fallback;
  }
  return text;
};
